import { Input } from "@/components/atoms/Input";
import { Tabs, TabsList, TabsTrigger } from "@/components/atoms/Tabs";
import usePersistent from "@/hooks/use-persistent";
import { useState } from "react";
import { useDebounce } from "use-debounce";
import { PayementsTab } from "./payements-tab.enum";
import PayementsTable from "./PayementsTable/PayementsTable";

const Payements = () => {
  const [searchText, setSearchText] = useState("");
  const [debouncedSearchText] = useDebounce(searchText, 300);
  const [tab, setTab] = usePersistent<PayementsTab>(
    "admin-dashboard-payements-tab",
    PayementsTab.All
  );

  return (
    <div className="flex flex-col bg-white h-screen">
      <div className="flex flex-col border-b border-b-gray-200 px-6 pt-3 gap-2 bg-white relative">
        <h1>Paiements</h1>
        <Tabs onValueChange={(e) => setTab(e as PayementsTab)} value={tab}>
          <TabsList variant="transparent" className="pb-0 mb-0">
            <TabsTrigger variant="underlineBlue" value={PayementsTab.All}>
              Tous
            </TabsTrigger>
            <TabsTrigger variant="underlineBlue" value={PayementsTab.Pending}>
              En attente
            </TabsTrigger>
            <TabsTrigger variant="underlineBlue" value={PayementsTab.Paid}>
              Payé
            </TabsTrigger>
            <TabsTrigger
              variant="underlineBlue"
              value={PayementsTab.NeedingConfirmation}
            >
              Nécessitant confirmation
            </TabsTrigger>
          </TabsList>
        </Tabs>
      </div>
      <div className="py-4 px-6 flex flex-col gap-3">
        <Input
          className="shadow-none"
          id="shadcn-input"
          searchIcon
          type="text"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value as string)}
          placeholder="Rechercher"
        />
        <PayementsTable tab={tab} searchText={debouncedSearchText} />
      </div>
    </div>
  );
};

export default Payements;
